export const enum ValidateValidatorType {
  Pattern = 'pattern',
  PackStation = 'packstation',
}

export const enum LengthValidatorType {
  Length = 'length',
}

export type ValidatorType = LengthValidatorType | ValidateValidatorType;
